import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete, Divider, Grid, IconButton } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  createIssueType,
  getCategories,
} from "../../slices/PrismIntegration/PrismIntegrationSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import CustomTextfield from "../CustomInputs/CustomTextfield";
import Toast from "../ToastContainer/CustomToast";
import CancelButtons from "./CancelButtons";
import SubmitButtons from "./SubmitButtons";

export default function CreateIssueTypeDialog(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [categories, setCategories] = useState([]);
  const { darkMode } = useContext(ThemeContext);

  const [payload, setPayload] = useState({
    name: "",
    categoryId: "",
    organization_id: props.data.propertyManagementId,
  });

  const [error, setError] = useState({
    name: false,
    cagtegoryId: false,
  });

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = () => {
    dispatch(getCategories())
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4000" && res.data) {
          setCategories(res.data);
        } else {
          setCategories([]);
        }
      });
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
    setError({
      ...error,
      name: false,
    });
  };

  const handleSubmit = () => {
    if (CommonUtil.isEmptyString(payload.name)) {
      Toast(t("ISSUE_TYPE_NAME_REQUIRED"), "error");
      setError({ ...error, name: true });
      return;
    }
    dispatch(createIssueType(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4065") {
          Toast(res.message, "success");
          props.handleCallBackData(res.data);
          props.handleClose();
          return;
        } else {
          Toast(res.message, "error");
          return;
        }
      });
  };

  return (
    <>
      <Dialog
        open={props.open}
        fullWidth={true}
        PaperProps={{
          style: {
            borderRadius: "20px !important",
            minWidth: "40vw",
            backgroundColor: darkMode ? "rgb(14, 42, 65)" : "#fff",
            color: darkMode ? "#fff" : "#434547",
          },
        }}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle variant="h4">
          <Grid
            container
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Grid item>
              <Typography
                style={{
                  color: darkMode ? "#fff" : "black",
                  fontSize: "20px",
                  fontWeight: "450",
                }}
              >
                {t("CREATE_ISSUE_TYPE")}
              </Typography>
            </Grid>
            <Grid item>
              <IconButton
                aria-label="close"
                onClick={props.handleClose}
                sx={{
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon onClick={props.handleClose} />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />

        <DialogContent
          style={{
            paddingBottom: "0px",
          }}
        >
          <Grid
            container
            justifyContent="center"
            columnSpacing={1}
            rowSpacing={2}
          >
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextfield
                label={t("COMMON014")}
                error={error.name}
                name="name"
                handleChange={handleChange}
                required={true}
                InputProps={{
                  style: {
                    color: darkMode ? "#fff" : "black",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Autocomplete
                popupIcon={<ExpandMoreIcon />}
                options={categories}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <CustomTextfield {...params} label={t("CATEGORIES")} />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: "center",
          }}
        >
          <CancelButtons
            variant="contained"
            color="secondary"
            onClick={props.handleClose}
          >
            <Typography variant="body1" style={{ textTransform: "none", fontSize: "14px", fontWeight: "400", fontFamily: "Roboto", color: "white" }}>
              {t("COMMON008")}
            </Typography>
          </CancelButtons>
          <SubmitButtons variant="contained" onClick={handleSubmit}>
            <Typography variant="body1" style={{ textTransform: "none", fontSize: "14px", fontWeight: "400", fontFamily: "Roboto", color: "white" }}>
              {t("COMMON007")}
            </Typography>
          </SubmitButtons>
        </DialogActions>
      </Dialog>
    </>
  );
}
